import React, { useState } from "react";
import PropTypes from "prop-types";
import { ArrowDownIcon } from "../../../components/Icons/ArrowDownIcon";
import CheckedIconSelected from "../../../components/Icons/CheckedIconSelected";
import { SORT_SUB_OPTIONS } from "../../../constants";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useWindowSize } from "../../../hook/useWindowSize";
import { IconSort } from "../../../components/Icons/IconSort";

function SortSub(props) {
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  const { filterData, setFilterData } = props;
  const { T } = useApp();
  const sortDefault = SORT_SUB_OPTIONS.find(
    (item) => item.value == filterData.sort
  );
  const [show, $show] = useState(false);
  const [sort, $sort] = useState(sortDefault?.value);
  const [title, $title] = useState(T(sortDefault?.text));

  const handleDropdown = () => {
    $show(!show);
  };
  const changeSort = (val) => {
    $sort(val);
    const sortSelected = SORT_SUB_OPTIONS.find((item) => item.value == val);
    $title(sortSelected.text);
    $show(false);
    setFilterData({ sort: val });
  };
  useEffect(() => {
    $title(sortDefault?.text);
    $sort(sortDefault?.value);
  }, [sortDefault]);
  return isMobile ? (
    <>
      <div className="relative">
        <div
          className="flex justify-center items-center h-[40px] w-[40px] bg-white gap-[8px] rounded-[10px] cursor-pointer"
          onClick={() => handleDropdown()}
        >
          <span className="flex">
            <IconSort />
          </span>
        </div>
        {show && (
          <div className="absolute right-0 top-[40px] z-10 w-[200px] rounded-[15px] shadow-lg bg-white pb-3">
            {SORT_SUB_OPTIONS.map((item) => {
              return (
                <div
                  className="flex justify-between items-center py-2.5 px-5 cursor-pointer"
                  onClick={() => changeSort(item.value)}
                  key={item.value}
                >
                  <span
                    className={`text-base ${
                      item.value == sort
                        ? " text-aia-red"
                        : " text-suzu-gray-7"
                    }`}
                  >
                    {T(item.text)}
                  </span>
                  {item.value == sort && <CheckedIconSelected />}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  ) : (
    <div className="relative min-w-[200px] min-lg:w-[247px]">
      <div
        className={
          "flex justify-between items-center py-[6px] px-5 h-[42px] w-full border border-suzu-gray-3 border-solid bg-white rounded-[10px]" +
          (show ? " relative z-20" : "")
        }
        onClick={handleDropdown}
      >
        <span className="text-sm text-black font-medium hidden lg:block">
          {T(title)}
        </span>
        {show && <ArrowDownIcon className="rotate-180 hidden lg:block" />}
        {!show && <ArrowDownIcon className="hidden lg:block" />}
      </div>
      {show && (
        <div className="absolute left-0 top-0 z-10 w-full rounded-[15px] shadow-lg bg-white pt-14 pb-3">
          {SORT_SUB_OPTIONS.map((item) => {
            return (
              <div
                className="flex justify-between items-center py-2.5 px-5 cursor-pointer"
                onClick={() => changeSort(item.value)}
                key={item.value}
              >
                <span
                  className={
                    "text-base" +
                    (item.value == sort
                      ? " text-aia-red"
                      : " text-suzu-gray-7")
                  }
                >
                  {T(item.text)}
                </span>
                {item.value == sort && <CheckedIconSelected />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

SortSub.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func,
};

export default SortSub;
